const adb2cauth = async () => {
    return fetch("Auth/GetAuthContext")
        .then(res => {
            return res.json();
        });
}

export default adb2cauth; 